import React from 'react';
import SectionTitle from '../../components/SectionTitle';
import SingleTeamTwo from '../../components/Team/SingleTeamTwo';

import shapeImg from '../../assets/img/about/shape-2-1.png';
import teamImg1 from '../../assets/img/team/team-2-1.png';
import teamImg2 from '../../assets/img/team/team-2-2.png';
import teamImg3 from '../../assets/img/team/team-2-3.png';

const Team = () => {
  return (
    <div
      id="it-team"
      className="it-team-2-area p-relative z-index pt-120 pb-90"
    >
      <div className="it-team-2-shape-2 d-none d-lg-block">
        <img src={shapeImg} alt="" />
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-5">
            <SectionTitle
              itemClass="it-team-2-title-box text-center mb-60"
              subTitle="Doctor"
              title="How I Work To improve Hospital"
            />
          </div>
        </div>
        <div className="row">
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".3s"
          >
            <SingleTeamTwo
              teamImage={teamImg1}
              authorName="Dr. Pauline W. Hamilton"
              specialist="FCPS (Medicine), FACP (USA)Professor & Head of
                  Department(Ex.)Medicine Specialist"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <SingleTeamTwo
              teamImage={teamImg2}
              authorName="Dr. Lawrence Weaver"
              specialist="FCPS (Medicine), FACP (USA)Professor & Head of
                  Department(Ex.)Medicine Specialist"
            />
          </div>
          <div
            className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <SingleTeamTwo
              teamImage={teamImg3}
              authorName="Dr. Larry Cassidy"
              specialist="FCPS (Medicine), FACP (USA)Professor & Head of
                  Department(Ex.)Medicine Specialist"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Team;
